// extracted by mini-css-extract-plugin
module.exports = {"userList":"TeamItem_userList__3MIBz"};